import _styled, { default as _styled2 } from "styled-components";
import * as RadixRadioGroup from "@radix-ui/react-radio-group";
type Option = {
  label: string;
  value: string;
};
type Props = {
  defaultValue?: string;
  label?: string;
  options: Option[];
  onChange?: (value: string) => void;
  value?: string;
};
const Item = /*#__PURE__*/_styled(RadixRadioGroup.Item).withConfig({
  componentId: "sc-sf-zzvra4-0"
})`
  &[type="button"] {
    ${{
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out"
}}
    ${{
  "height": "3.2rem",
  "whiteSpace": "nowrap",
  "borderRadius": "2px",
  "paddingLeft": "var(--spacing-md)",
  "paddingRight": "var(--spacing-md)",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "outlineWidth": "0px",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.016rem",
    "fontWeight": "400"
  }
}}
    ${{
  "backgroundColor": "var(--bg-secondary)"
}}
    ${{
  "&:hover": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(75 46 248 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  }
}}

    &[data-state="checked"] {
      ${{
  "--tw-border-opacity": "1",
  "borderColor": "rgb(75 46 248 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}}
    }
  }
`;
export function Filter(props: Props) {
  const {
    label,
    options,
    onChange,
    value,
    ...rest
  } = props;
  return <_StyledRadixRadioGroupRoot className="hide-scrollbar" onValueChange={val => onChange?.(val)} value={value} orientation="horizontal" aria-label={label} {...rest}>
      {options.map(({
      label,
      value
    }, idx) => <div key={idx}>
          <label>
            <Item value={value}>{label}</Item>
          </label>
        </div>)}
    </_StyledRadixRadioGroupRoot>;
}
var _StyledRadixRadioGroupRoot = /*#__PURE__*/_styled2(RadixRadioGroup.Root).withConfig({
  displayName: "filter___StyledRadixRadioGroupRoot",
  componentId: "sc-1ljjis1-0"
})({
  "display": "flex",
  "flexWrap": "nowrap",
  "gap": "var(--spacing-sm)",
  "overflowX": "scroll",
  "borderRadius": "4px",
  "padding": "var(--spacing-md)",
  "@media (min-width: 1024px)": {
    "gap": "0",
    "overflowX": "hidden",
    "backgroundColor": "var(--bg-secondary)",
    "padding": "var(--spacing-xs)"
  }
});